import { render, staticRenderFns } from "./pie-chart-widget.vue?vue&type=template&id=299b89b0&scoped=true"
import script from "./pie-chart-widget.vue?vue&type=script&lang=js"
export * from "./pie-chart-widget.vue?vue&type=script&lang=js"
import style0 from "./pie-chart-widget.vue?vue&type=style&index=0&id=299b89b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299b89b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('299b89b0')) {
      api.createRecord('299b89b0', component.options)
    } else {
      api.reload('299b89b0', component.options)
    }
    module.hot.accept("./pie-chart-widget.vue?vue&type=template&id=299b89b0&scoped=true", function () {
      api.rerender('299b89b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/chart-widget/pie-chart-widget.vue"
export default component.exports